import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import cartConfig from "emun.cart/cart.config";
import AutoQuery from "servicestack/auto-query/auto-query";
import Product from "emun.shopping/product.model";
import resolve from "ioc/resolve";
import csvParser from 'webutils/services/csv-json';

export default class OrderParseItemsController {
	constructor($rootScope, options) {
        const $ctrl = this;
        basicController($ctrl);
        $ctrl.bus = new ServiceBus();
        $ctrl.config = cartConfig;
		$ctrl.title = options.title || "Enter item(s)";
		$ctrl.subTitle = "Enter a list of items and quantities separated by a comma (i.e. ITEMABC,24)";
		$ctrl.results = [];
		$ctrl.parts = [];

    }
	setMinimums() {
		let $ctrl = this;
		$ctrl.results.map(p => p.qty = p.minimumOrderQty);
	}
	save() {
		const $ctrl = this;
		$ctrl.lines = [];
		$ctrl.bus.validationErrors = [];
		let result = $ctrl.results.reduce((accumulatorPromise, part) => {
			return accumulatorPromise.then(() => {
				if (part.qty > 0) {
					var item = part.isInCart() ? $ctrl.$cart.itemIndex[part.id] : {};
					item.qtyPurchased = item.quantity = part.qty;
					item.notes = part.notes;
					if (part.priceOverride !== part.price) {
						item.priceOverride = part.priceOverride;
					}
					return part.isInCart() ? $ctrl.$cart.changeOptions(item, part) : $ctrl.$cart.addItem(item, part, true, '', true);
				}
			});
		}, Promise.resolve());
		result.then(() => {
			$ctrl.$cart.load();
			$ctrl.$close();
		});
		//$ctrl.results.forEach(function(part, index) {
		//	if (part.qty > 0) {
		//		var item = {};
		//		item.qtyPurchased = item.quantity = part.qty;
		//		item.notes = part.notes;
		//		if (part.priceOverride !== part.price) {
		//			item.priceOverride = part.priceOverride;
		//		}
		//		item.product = part;
		//		$ctrl.lines.push(item);
		//	}
		//});

		//if ($ctrl.lines.length > 0) {
		//	$ctrl.$cart.addMultipleItems($ctrl.lines).then(() => {
		//		$ctrl.$cart.load($ctrl.$cart.id);
		//		$ctrl.$close();
		//	});
		//}
	}

	reset() {
		let $ctrl = this;
		$ctrl.parts = [];
		$ctrl.text = "";
	}

	processText(text) {
		let $ctrl = this;
		var content = {
			csv: text.replace(/\r\n|\r/g, "\n"),
			header: false,
			separator: ","
		};
		$ctrl.content = content.csv;
		var lines = content.csv.split(
			new RegExp('\n(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)')
		);
		var columncount = lines[0].split(content.separator).length;

		if (columncount == 0 || lines.length == 0) return;

		var header = "id\r\n";
		if (columncount > 1) header = "id,qty\r\n";

		text = header + text;
		$ctrl.parts = [];
		$ctrl.parts = csvParser.parse(text);
		let $rootScope = resolve('$rootScope');
		if ($ctrl.parts.length > 0) $rootScope.$broadcast('refreshPartsEntryGrid');
	}
}

